import {
  WorkflowTemplateDto,
  CreateWorkflowTemplateRequest,
  UpdateWorkflowTemplateRequest,
} from '../types';
import { HttpClient } from './http-client';

export class WorkflowTemplateService {
  constructor(private httpClient: HttpClient) {}

  async getTemplates(divisionId: string, active?: boolean): Promise<WorkflowTemplateDto[]> {
    const query = active === undefined ? '' : `?active=${active}`;
    return this.httpClient.get<WorkflowTemplateDto[]>(
      `/api/divisions/${divisionId}/workflow-templates${query}`
    );
  }

  async getTemplate(divisionId: string, id: string): Promise<WorkflowTemplateDto> {
    return this.httpClient.get<WorkflowTemplateDto>(
      `/api/divisions/${divisionId}/workflow-templates/${id}`
    );
  }

  async createTemplate(
    divisionId: string,
    request: CreateWorkflowTemplateRequest
  ): Promise<WorkflowTemplateDto> {
    return this.httpClient.post<WorkflowTemplateDto>(
      `/api/divisions/${divisionId}/workflow-templates`,
      request
    );
  }

  async updateTemplate(
    divisionId: string,
    id: string,
    request: UpdateWorkflowTemplateRequest
  ): Promise<WorkflowTemplateDto> {
    return this.httpClient.put<WorkflowTemplateDto>(
      `/api/divisions/${divisionId}/workflow-templates/${id}`,
      request
    );
  }

  async deleteTemplate(divisionId: string, id: string): Promise<void> {
    await this.httpClient.delete<void>(`/api/divisions/${divisionId}/workflow-templates/${id}`);
  }
}
